import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ClientUser = {
  id: string;
  name?: string | null;
  phone?: string | null;
  email?: string | null;
};

type AuthState = {
  accessToken: string | null;
  refreshToken: string | null;
  user: ClientUser | null;
  isHydrated: boolean;
  setSession: (s: { accessToken: string; refreshToken: string; user: ClientUser }) => void;
  setUser: (u: ClientUser) => void;
  logout: () => void;
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      isHydrated: false,
      setSession: (s) => set({
        accessToken: s.accessToken,
        refreshToken: s.refreshToken,
        user: s.user,
      }),
      setUser: (u) => set({ user: u }),
      logout: () => set({ accessToken: null, refreshToken: null, user: null }),
    }),
    {
      name: 'resstro_menu_auth',
      onRehydrateStorage: () => (state) => { if (state) state.isHydrated = true; },
    },
  ),
);
